import { MasonryPhotoAlbum } from "react-photo-album";
import "react-photo-album/masonry.css";

import styles from "../styles/gallery.module.css";

const photos = [
  { src: process.env.PUBLIC_URL + "/images/17.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/4.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/22.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/9.jpeg", width: 1200, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/1.jpeg", width: 800, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/25.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/6.jpeg", width: 1200, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/13.jpeg", width: 800, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/28.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/3.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/26.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/11.jpeg", width: 800, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/29.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/8.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/5.jpeg", width: 1200, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/24.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/2.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/30.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/18.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/12.jpeg", width: 800, height: 800 },
{ src: process.env.PUBLIC_URL + "/images/27.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/21.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/7.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/10.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/20.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/23.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/15.jpeg", width: 800, height: 1200 },
{ src: process.env.PUBLIC_URL + "/images/19.jpeg", width: 800, height: 1200 },


];

function Gallery() {
  return (
    <section id="gallery" className={styles.container}>
      <h1 className={styles.title}>2025 Gallery</h1>
      <MasonryPhotoAlbum photos={photos} columns={4} spacing={10} />
    </section>
  )
}

export default Gallery;